import { useApp } from '../store';
import { displayName, initials } from '../people';
import VendorTag from './VendorTag';
import Icon from './Icon';

/**
 * Your account, at the right of the top bar.
 *
 * IT USED TO BE THE ACCOUNT ITSELF. First a dropdown, then a window over the
 * board, then a block at the foot of the sidebar — and the sidebar foot grew
 * crowded. So it sits in the top bar now, beside the notification bell: an
 * avatar on its own at rest, widening to your name on hover or keyboard focus,
 * and still a way somewhere rather than a menu over the board — clicking it
 * goes to your account, the same as People and access, with the same way back.
 *
 * At rest it is just the avatar, the same size and corner as the bell, so the
 * bar reads as one row of controls; on a touch screen, where there is no hover,
 * it stays the avatar and a tap opens the account.
 */
export default function AccountMenu() {
  const user = useApp((s) => s.user);
  const profiles = useApp((s) => s.profiles);
  const view = useApp((s) => s.view);
  const setView = useApp((s) => s.setView);

  const email = (user?.email ?? '').toLowerCase();

  return (
    <button
      className={`topbar-account ${view === 'account' ? 'active' : ''}`}
      onClick={() => setView('account')}
      aria-current={view === 'account' ? 'page' : undefined}
      aria-label="Your account"
      title="Your account"
    >
      <span className="avatar-me">{initials(email, profiles)}</span>
      {/* Name + caret ride in one wrapper that is clipped to nothing at rest and
          widens on hover/focus. Animating the WRAPPER's own max-width (a length,
          never `auto`) is what makes the open glide instead of jump; the button
          just follows its content. Keeping them together also means the resting
          box has no phantom gap pushing the avatar off-centre. */}
      <span className="tb-reveal">
        <span className="tb-name">{displayName(email, profiles)}</span>
        <VendorTag who={email} profiles={profiles} compact />
        <Icon name="chevron" size={18} className="tb-caret" />
      </span>
    </button>
  );
}
